import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.tsx';
import './styles/base.css';

// O modo escuro segue o sistema. O atributo vive na raiz do documento e só
// esta aplicação o escreve — o painel de administração fica no tema claro até
// ter a sua própria decisão. Escrito antes do render, para a primeira pintura
// já sair no tema certo em vez de piscar de claro para escuro.
const preferenciaEscura = window.matchMedia('(prefers-color-scheme: dark)');
const aplicarTema = () => {
  document.documentElement.dataset.tema = preferenciaEscura.matches ? 'escuro' : 'claro';
};
aplicarTema();
preferenciaEscura.addEventListener('change', aplicarTema);

const host = document.getElementById('root');
if (!host) throw new Error('elemento #root em falta em index.html');

createRoot(host).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
